import React from "react";
import moment from "moment";
import { getLnamDisplayLabel } from "../../../orderPunching/formUtils";

/** Matches Django REST default page size for /orders/list */
export const ORDER_LIST_PAGE_SIZE = 20;

export const formatOrderDateTime = (value) => {
  if (value == null || value === "") return null;
  return moment(value).format("DD MMM YYYY, HH:mm");
};

export const getOrderRowClassName = (record) => {
  if (record && record.urgent) return "order-row--urgent";
  return "";
};

export const renderOrderNumberCell = (text, record, onClick) => (
  <div className="order-no-cell">
    <p className="validate-link" onClick={onClick}>
      {text}
    </p>
    {record && record.urgent ? (
      <div className="order-no-cell__flags">
        <span className="order-flag order-flag--urgent">Urgent</span>
      </div>
    ) : null}
  </div>
);

export const renderReferenceIdCell = (text) =>
  text ? (
    <span className="order-ref-id">{text}</span>
  ) : (
    <span className="order-cell-muted">—</span>
  );

export const renderDateTimeCell = (text) => {
  const formatted = formatOrderDateTime(text);
  if (!formatted) {
    return <span className="order-cell-muted">—</span>;
  }
  return <span className="order-datetime">{formatted}</span>;
};

export const renderSourceCell = (text) => {
  if (!text) return <span className="order-cell-muted">—</span>;
  const slug = String(text)
    .toLowerCase()
    .replace(/\s+/g, "-");
  return (
    <span className={`order-source-pill order-source-pill--${slug}`}>
      {text}
    </span>
  );
};

export const renderCustomerCell = (text, record) => {
  const name =
    (record && record.customer && record.customer.name) || text || null;
  const nickname =
    record && record.customer && record.customer.nickname
      ? record.customer.nickname
      : null;
  if (!name) return <span className="order-cell-muted">—</span>;
  return (
    <div className="order-customer-cell">
      <span className="order-customer-cell__name">{name}</span>
      {nickname ? (
        <span className="order-customer-cell__nick">{nickname}</span>
      ) : null}
    </div>
  );
};

export const renderCoatingCell = (text) =>
  text ? (
    <span className="order-chip order-chip--coating">{text}</span>
  ) : (
    <span className="order-cell-muted">—</span>
  );

export const renderLnamCell = (text, record) => {
  const lnam = record && record.lnam;
  const name = (lnam && lnam.name) || text;
  if (!name && !(lnam && lnam.id)) {
    return <span className="order-cell-muted">—</span>;
  }

  const description = (lnam && lnam.description) || null;
  const fallbackLabel = description ? `${name} - ${description}` : name || "";
  const displayLabel = getLnamDisplayLabel(
    record && record.product_group,
    lnam && lnam.id,
    fallbackLabel
  );
  const hasCustomDisplay =
    displayLabel &&
    displayLabel !== fallbackLabel &&
    displayLabel !== name;

  if (hasCustomDisplay) {
    return (
      <div className="order-lnam-cell">
        <span className="order-lnam-cell__code" title={description || name}>
          {displayLabel}
        </span>
        {name && name !== displayLabel ? (
          <span className="order-lnam-cell__desc" title={name}>
            {name}
          </span>
        ) : null}
      </div>
    );
  }

  return (
    <div className="order-lnam-cell">
      <span className="order-lnam-cell__code">{name}</span>
      {description ? (
        <span className="order-lnam-cell__desc" title={description}>
          {description}
        </span>
      ) : null}
    </div>
  );
};

export const renderOrderTypeCell = (text, record) => (
  <span
    className={`order-type-pill order-type-pill--${
      record && record.is_stock ? "stock" : "rx"
    }`}
  >
    {record && record.is_stock ? "Stock" : "RX"}
  </span>
);

export const renderLabelsCell = (text, record) => {
  const labels = (record && record.label) || [];
  if (!labels.length) {
    return <span className="order-cell-muted">—</span>;
  }
  return (
    <div className="order-labels-cell">
      {labels.map((item, index) => (
        <span className="order-chip order-chip--label" key={index}>
          {item.label && item.label.short_code}
        </span>
      ))}
    </div>
  );
};
